// frontend/src/components/InfraAppTypeForm.js
import React from 'react';
import {OverlayTrigger, Popover} from "react-bootstrap";

const popoverInfraAppVersion = (
    <Popover id="popover-basic">
        <Popover.Body>
            Version of Infra App to deploy. This field is mandatory <br/><br/>
            You have to enter the exact version of Infrastructure App to deploy.
        </Popover.Body>
    </Popover>
);


const InfraAppTypeForm = ({
                              currentPath,
                              versionFields,
                              handleVersionChange,
                              triggerUpdateAppPipeline,
                              triggerArgoAppUpdatePipeline,
                              pipelineState,
                              actionInProgress,
                              goBack
                          }) => (
    <div className="card shadow-sm">
        <div className="card-body ps-4 pe-4">
            <div className='d-flex flex-row align-items-baseline gap-2 mb-4'>
                {currentPath && (
                    <button className="btn d-flex align-items-center" type="button" onClick={goBack}>
                        <i className="bi bi-arrow-left me-2"></i>
                    </button>
                )}
                <h3 className="h5 text-primary mb-3">Infra App: {currentPath.split('/').pop()} </h3>
            </div>

            <div className="d-inline-flex justify-content-around w-100 gap-5">

                <div className="w-100">
                    <h5>Update</h5>
                    <p className="p-2 text-bg-light text-black-50">Be sure to monitor the pipeline closely to ensure the
                        update is operational.</p>
                    <div className="mb-3 mt-4">
                        <label className="form-label">Infra App Version:
                            <OverlayTrigger trigger="hover" placement="right" overlay={popoverInfraAppVersion}>
                                <i className="bi bi-question-circle ms-2"></i>
                            </OverlayTrigger>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={versionFields.infraAppVersion}
                            onChange={(e) => handleVersionChange("infraAppVersion", e.target.value)}
                            placeholder="Enter Infra App Version"
                        />
                    </div>
                    <button
                        className={`btn ${
                            pipelineState === "idle"
                                ? "btn-primary"
                                : pipelineState === "loading"
                                    ? "btn-warning"
                                    : pipelineState === "success"
                                        ? "btn-success"
                                        : "btn-danger"
                        } d-flex align-items-center justify-content-center`}
                        onClick={triggerUpdateAppPipeline}
                        disabled={pipelineState === "loading"}
                    >
                        {pipelineState === "loading" ? (
                            <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"
                              aria-hidden="true"></span>
                                Triggering...
                            </>
                        ) : pipelineState === "success" ? (
                            <>
                                <i className="bi bi-check-circle-fill me-2"></i>
                                Success
                            </>
                        ) : pipelineState === "failed" ? (
                            <>
                                <i className="bi bi-exclamation-circle-fill me-2"></i>
                                Failed
                            </>
                        ) : (
                            "Trigger Pipeline"
                        )}
                    </button>
                </div>
                <div className=""></div>
                <div className="vr"></div>
                <div className=""></div>
                <div className="w-100">
                    <h5>Actions</h5>
                    <p className="p-2 text-bg-light text-black-50 w-100">One rule: If you wonder what it's for, move
                        along!</p>
                    <div className="d-inline-flex gap-3 mb-3 mt-3">
                        {!actionInProgress && (
                            <>
                                <button className="btn btn-outline-info d-flex align-items-center"
                                        type="button"
                                        onClick={triggerArgoAppUpdatePipeline}>
                                    <i className="bi bi-arrow-clockwise  me-2"></i> Argo App Update
                                </button>
                            </>
                        )}

                        {actionInProgress && (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        )}
                    </div>

                </div>


            </div>
        </div>
    </div>
);

export default InfraAppTypeForm;
